import React from 'react';
import { useCollaborationContext } from '../CollaborationProvider';

/**
 * Liste des utilisateurs connectés dans la sidebar
 * Visible uniquement pour certains rôles
 */
const SidebarConnectedUsers = ({ isCollapsed, userRole }) => {
  const { connectedUsers, isConnected } = useCollaborationContext();

  // Rôles autorisés à voir les utilisateurs connectés
  const allowedRoles = ['Admin', 'Comptabilité', 'RH', 'Administrative', 'Planificateur'];

  // Vérifier si le rôle actuel est autorisé
  const canSeeConnectedUsers = allowedRoles.some(role =>
    userRole?.toLowerCase() === role.toLowerCase()
  );

  if (!canSeeConnectedUsers) {
    return null;
  }

  // Obtenir les initiales
  const getInitials = (name) => {
    if (!name) return '?';
    const parts = name.split(' ');
    if (parts.length >= 2) {
      return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
    }
    return name.substring(0, 2).toUpperCase();
  };

  // Filtrer pour ne pas dupliquer (par odre de connexion)
  const uniqueUsers = connectedUsers?.filter((user, index, self) =>
    index === self.findIndex(u => u.odre === user.userId || u.userName === user.userName)
  ) || [];

  return (
    <div className="sidebar-connected">
      <div className="sidebar-connected-header">
        <span className="sidebar-connected-dot" />
        <span>En ligne ({uniqueUsers.length})</span>
      </div>

      {uniqueUsers.length > 0 ? (
        <div className="sidebar-connected-list">
          {uniqueUsers.slice(0, 5).map((user, index) => (
            <div key={user.odre || index} className="sidebar-connected-user">
              <div className="sidebar-connected-avatar">
                {getInitials(user.userName)}
              </div>
              <span className="sidebar-connected-name">
                {user.userName}
              </span>
            </div>
          ))}
          {uniqueUsers.length > 5 && !isCollapsed && (
            <div className="sidebar-connected-user" style={{
              fontSize: '11px',
              color: '#64748b',
              justifyContent: 'center'
            }}>
              +{uniqueUsers.length - 5} autre(s)
            </div>
          )}
        </div>
      ) : (
        !isCollapsed && (
          <div style={{
            fontSize: '12px',
            color: '#94a3b8',
            padding: '8px',
            textAlign: 'center'
          }}>
            {isConnected ? 'Vous êtes seul connecté' : 'Connexion...'}
          </div>
        )
      )}
    </div>
  );
};

export default React.memo(SidebarConnectedUsers);
